import ReportService from '@/service/report'
export default {
  organizationReport ({commit}, payload) {
    return new Promise((resolve, reject) => {
      ReportService.organizationReport(payload.organization, payload.data).then(res => {
        commit('organizationReport', res.data.data)
        commit('setType', payload)
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },
  hashtagReport ({commit}, payload) {
    return new Promise((resolve, reject) => {
      ReportService.hashtagReport(payload.data).then(res => {
        commit('hashtagReport', res.data.data)
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },
  getReportFix ({commit}, payload) {
    return new Promise((resolve, reject) => {
      ReportService.getReportFix(payload.checklist).then(res => {
        commit('reportCorrective', res.data.data)
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/module/report/actions.js